import { render } from "./PartLogisticsInfo.vue?vue&type=template&id=b1b6b166&scoped=true&bindings={}"
import script from "./PartLogisticsInfo.vue?vue&type=script&lang=ts"
export * from "./PartLogisticsInfo.vue?vue&type=script&lang=ts"

import "./PartLogisticsInfo.vue?vue&type=style&index=0&id=b1b6b166&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b1b6b166"

export default script